export * from './BackgroundImage';
//# sourceMappingURL=index.js.map